import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, InputSignal, OnInit, computed, effect, inject, input } from "@angular/core";
import { EvCore } from "ev-core";
import { EvCircularProgressComponent } from "src/app/shared-components/ev-circular-progress/ev-circular-progress.component";
import { ImageCarouselComponent } from "src/app/shared-components/image-carousel/image-carousel.component";
import { ImagePackage } from "src/models/common/image.model";
import { MiniInfocardEstateSale } from "src/models/estate/mini-infocard-estate.model";
import { Owner } from "src/models/units/owner.model";
import { EVEstateType } from "src/models/units/unit-attributes.model";
import { ExternalLinksService } from "src/services/externallinks.service";
import { ResourceService } from "src/services/resources/resource.service";
import { ConvertUtil } from "src/util/tools/convert.util";

@Component({
    selector: "mini-infocard-image-carousel",
    imports: [EvCore, EvCircularProgressComponent, ImageCarouselComponent, DatePipe],
    templateUrl: "./mini-infocard-image-carousel.component.html",
    styleUrl: "./mini-infocard-image-carousel.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniInfocardImageCarouselComponent implements OnInit {
    //Todo - create a shared model for all miniInfocards and map outside the component
    selectedSale: InputSignal<MiniInfocardEstateSale> = input.required();
    imagePackages: InputSignal<ImagePackage[]> = input.required();

    streetViewUrl: string = "";
    private readonly exLinksService: ExternalLinksService = inject(ExternalLinksService);
    private readonly resourceService = inject(ResourceService);

    protected propertyImageClass = computed(() => {
        const estateType = ConvertUtil.estateTypeToCssString(this.selectedSale()?.estateType ?? EVEstateType.Annet);
        return `${estateType}`;
    });

    constructor() {
        effect(() => {
            if (this.imagePackages()) {
                this.mapImagesToUrls(this.imagePackages());
            }
        });
    }

    ngOnInit(): void {
        this.streetViewUrl = this.exLinksService.makeStreetViewUrl(this.selectedSale().latitude, this.selectedSale().longitude);
    }

    getOwnerPercentage(owner: Owner): number {
        if (owner?.ownerShare?.numerator && owner?.ownerShare?.denominator) {
            return (owner.ownerShare.numerator / owner.ownerShare.denominator) * 100;
        }
        return 0;
    }

    private mapImagesToUrls(incomingImagePackages: ImagePackage[]): any {
        if (incomingImagePackages != null && incomingImagePackages.length > 0) {
            incomingImagePackages.forEach((imagePackage: any) => {
                if (imagePackage.images && imagePackage.images.length > 0 && !imagePackage.isBlom) {
                    imagePackage.images.forEach((image: any) => {
                        image.imageUrl = this.resourceService.getImageUrl(image.imageId);
                        image.imageThumbnailUrl = this.resourceService.getImageUrl(image.imageId, true);
                    });
                }
            });
        }
        return incomingImagePackages || [];
    }
}
